export interface WallJoints {
    wallVerticesIds: Array<number>;
    relatedVerticesIds: Array<number>;
    topId: number;
    bottomId: number;
    archWeight: number;
    heelWeight: number;
    maxAngle: number;
    minAngle: number;
    centerId: number;
    side: 'Medial' | 'Lateral' | 'Heel';
}

export const ArchWallMedial: WallJoints = {
    wallVerticesIds: [121, 52, 53, 167],
    relatedVerticesIds: [281, 280],
    topId: 121,
    bottomId: 167,
    archWeight: 1,
    heelWeight: 0,
    maxAngle: 50.18,
    minAngle: 5,
    centerId: 296,
    side: 'Medial'
}

export const ArchWallMedialPlus1: WallJoints = {
    wallVerticesIds: [142, 51, 54, 166],
    relatedVerticesIds: [283, 325],
    topId: 142,
    bottomId: 166,
    archWeight: 1,
    heelWeight: 0,
    maxAngle: 54.03,
    minAngle: 5,
    centerId: 324,
    side: 'Medial'
}

export const ArchWallMedialPlus2: WallJoints = {
    wallVerticesIds: [141, 140, 139, 200],
    relatedVerticesIds: [273, 270],
    topId: 141,
    bottomId: 200,
    archWeight: 1,
    heelWeight: 0,
    maxAngle: 43.23,
    minAngle: 5,
    centerId: 301,
    side: 'Medial'
}

export const ArchWallMedialMinus1: WallJoints = {
    wallVerticesIds: [122, 123, 181, 180],
    relatedVerticesIds: [282, 279],
    topId: 122,
    bottomId: 180,
    archWeight: 0.84,
    heelWeight: 0.16,
    maxAngle: 49.51,
    minAngle: 5,
    centerId: 297,
    side: 'Medial'
}

export const ArchWallMedialMinus2: WallJoints = {
    wallVerticesIds: [256, 185, 177, 176],
    relatedVerticesIds: [311, 320],
    topId: 256,
    bottomId: 176,
    archWeight: 0.5,
    heelWeight: 0.5,
    maxAngle: 53.78,
    minAngle: 5,
    centerId: 319,
    side: 'Medial'
}

export const ArchWallMedialMinus3: WallJoints = {
    wallVerticesIds: [237, 239, 162, 161],
    relatedVerticesIds: [310, 321],
    topId: 237,
    bottomId: 161,
    archWeight: 0.16,
    heelWeight: 0.84,
    maxAngle: 55.82,
    minAngle: 5,
    centerId: 308,
    side: 'Medial'
}

export const ArchWallLateral: WallJoints = {
    wallVerticesIds: [128, 56, 57, 169],
    relatedVerticesIds: [277, 295],
    topId: 128,
    bottomId: 169,
    archWeight: 1,
    heelWeight: 0,
    maxAngle: 53.44,
    minAngle: 5,
    centerId: 296,
    side: 'Lateral'
}

export const ArchWallLateralPlus1: WallJoints = {
    wallVerticesIds: [129, 130, 143, 197],
    relatedVerticesIds: [326, 327],
    topId: 129,
    bottomId: 197,
    archWeight: 1,
    heelWeight: 0,
    maxAngle: 50.86,
    minAngle: 5,
    centerId: 324,
    side: 'Lateral'
}

export const ArchWallLateralPlus2: WallJoints = {
    wallVerticesIds: [255, 59, 62, 172],
    relatedVerticesIds: [275, 298],
    topId: 255,
    bottomId: 172,
    archWeight: 1,
    heelWeight: 0,
    maxAngle: 36.49,
    minAngle: 5,
    centerId: 301,
    side: 'Lateral'
}

export const ArchWallLateralMinus1: WallJoints = {
    wallVerticesIds: [138, 55, 58, 168],
    relatedVerticesIds: [278, 294],
    topId: 138,
    bottomId: 168,
    archWeight: 0.84,
    heelWeight: 0.16,
    maxAngle: 53.09,
    minAngle: 5,
    centerId: 297,
    side: 'Lateral'
}

export const ArchWallLateralMinus2: WallJoints = {
    wallVerticesIds: [137, 136, 135, 182],
    relatedVerticesIds: [322, 323],
    topId: 137,
    bottomId: 182,
    archWeight: 0.5,
    heelWeight: 0.5,
    maxAngle: 56.28,
    minAngle: 5,
    centerId: 319,
    side: 'Lateral'
}

export const ArchWallLateralMinus3: WallJoints = {
    wallVerticesIds: [258, 144, 145, 175],
    relatedVerticesIds: [314, 307],
    topId: 258,
    bottomId: 175,
    archWeight: 0.16,
    heelWeight: 0.84,
    maxAngle: 57.86,
    minAngle: 5,
    centerId: 308,
    side: 'Lateral'
}

export const HeelMedialToLateral1: WallJoints = {
    wallVerticesIds: [238, 63, 66, 163],
    relatedVerticesIds: [331, 312],
    topId: 238,
    bottomId: 163,
    archWeight: 0,
    heelWeight: 1,
    maxAngle: 58.35,
    minAngle: 5,
    centerId: 309,
    side: 'Heel'
}

export const HeelMedialToLateral2: WallJoints = {
    wallVerticesIds: [259, 64, 65, 146],
    relatedVerticesIds: [330, 313],
    topId: 259,
    bottomId: 146,
    archWeight: 0,
    heelWeight: 1,
    maxAngle: 59.66,
    minAngle: 5,
    centerId: 309,
    side: 'Heel'
}

export const HeelMedialToLateral3: WallJoints = {
    wallVerticesIds: [260, 71, 72, 147],
    relatedVerticesIds: [329, 328],
    topId: 260,
    bottomId: 147,
    archWeight: 0,
    heelWeight: 1,
    maxAngle: 59.12,
    minAngle: 5,
    centerId: 309,
    side: 'Heel'
}

export const HeelMedialToLateral4: WallJoints = {
    wallVerticesIds: [261, 67, 70, 153],
    relatedVerticesIds: [318, 317],
    topId: 261,
    bottomId: 153,
    archWeight: 0,
    heelWeight: 1,
    maxAngle: 58.81,
    minAngle: 5,
    centerId: 309,
    side: 'Heel'
}

export const HeelMedialToLateral5: WallJoints = {
    wallVerticesIds: [178, 68, 69, 154],
    relatedVerticesIds: [284, 316],
    topId: 178,
    bottomId: 154,
    archWeight: 0,
    heelWeight: 1,
    maxAngle: 60.08,
    minAngle: 5,
    centerId: 309,
    side: 'Heel'
}

export const HeelMedialToLateral6: WallJoints = {
    wallVerticesIds: [179, 47, 50, 164],
    relatedVerticesIds: [263, 315],
    topId: 179,
    bottomId: 164,
    archWeight: 0,
    heelWeight: 1,
    maxAngle: 60.05,
    minAngle: 5,
    centerId: 309,
    side: 'Heel'
}

export const HeelMedialToLateral7: WallJoints = {
    wallVerticesIds: [257, 48, 49, 165],
    relatedVerticesIds: [262, 306],
    topId: 257,
    bottomId: 165,
    archWeight: 0,
    heelWeight: 1,
    maxAngle: 58.7,
    minAngle: 5,
    centerId: 309,
    side: 'Heel'
}

export const archWallJoints = [ArchWallMedial, ArchWallMedialPlus1, ArchWallMedialPlus2, ArchWallLateral, ArchWallLateralPlus1, ArchWallLateralPlus2]
export const heelWallJoints = [HeelMedialToLateral1, HeelMedialToLateral2, HeelMedialToLateral3, HeelMedialToLateral4, HeelMedialToLateral5, HeelMedialToLateral6, HeelMedialToLateral7];
export const archHeelWallJoints = [ArchWallMedialMinus1, ArchWallMedialMinus2, ArchWallMedialMinus3, ArchWallLateralMinus1, ArchWallLateralMinus2, ArchWallLateralMinus3];